export default class CreateExecUsereObjID{
    constructor({ID:id,Type:type,CreateExecType:createExecType}){
        this.ID = id;
        this.Type = type;
        this.CreateExecType = createExecType;
    }
    toString(){
        return JSON.stringify(this);
    }
}